<template>
    <div class="bg-white sticky-header">
        <div class="py-3 m-0 subject-title align-items-center mobile">
            <span v-if="show"  class="pr-2 close-button" v-on:click="back">
                <v-icon name="chevron-left" scale="1.2" class="arrow-left"></v-icon>
            </span>
           <span>{{title}}</span> 
        </div>
    </div>
</template>

<script>
    import CommonCode from './mixins/CommonCode';
    export default {
        props: {
            title: {
                type: String,
                required: true,
                default:''
            },
            show: {
                type: Boolean
            }
        },

        mixins: [ CommonCode ]
    }
</script>

<style scoped>
@media (max-width:786px){
.mobile{
padding: 0 16px;

}
}
</style>
